module.exports = __webpack_public_path__ + "static/img/12.0a68294.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/eng/12.png
// module id = i34Z
// module chunks = 0